<template>
  <div>
    <div class="row" style="padding: 1%;">
      <loading
        loader="dots"
        :height="170"
        :width="170"
        color="#3282b8"
        background-color="#505273"
        transition="fade"
        :active="isLoading"
        :is-full-page="true"
      ></loading>
      <div class="col-lg-12">
        <h4
          class="info-text"
        >Bahagian D - Rancangan Tindakan Pencegahan Dan/Atau Tindakan Pembetulan</h4>
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-9">
              <u>
                <p>Nota Penting</p>
              </u>
              <ol>
                <li>
                  <p style="font-style: italic">
                    Gunakan
                    <b>6 langkah kawalan</b> (mengikut hiraki) di dalam merangka rancangan tindakan pencegahan dan/atau tindakan pembetulan.
                  </p>
                </li>
                <li>
                  <p style="font-style: italic">
                    Sila masukkan
                    <b>tarikh perlaksanaan/siap</b> bagi setiap rancangan.
                  </p>
                </li>
                <li>
                  <p style="font-style: italic">
                    Jika ada langkah kawalan yang tidak sesuai atau berkaitan sila tulis "
                    <b>tidak berkaitan</b>"
                  </p>
                </li>
              </ol>
            </div>
            <!-- <div class="col-lg-3" style="border-left: solid red 1px">
              <base-input  label="Property Damage" ></base-input>
            </div> -->
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-sm-11">
            <!-- <el-table
              :data="tableETD"
              style="border: solid red; border-radius: 10px; margin-top: 3%"
            >
              <el-table-column
                min-width="100"
                align="center"
                label="Langkah Kawalan"
                :prop="langkahKawalan"
              >
                <el-select v-model="langkahKawalan">
                  <el-option
                    v-for="option in selects.kawalan"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  ></el-option>
                </el-select>
              </el-table-column>
              <el-table-column
                min-width="250"
                align="center"
                label="Rancangan Tindakan Pencegahan / Pembetulan"
                :prop="tindakanPencegahan"
                required="true"
              >
                <textarea class="huraian" v-model="tindakanPencegahan"></textarea>
              </el-table-column>

              <el-table-column
                min-width="120"
                align="center"
                label="Tarikh Perlaksanaan / Siap"
                :prop="tarikSiap"
              >
                  <el-date-picker v-model="tarikSiap" type="date"></el-date-picker>
              </el-table-column>
              <el-table-column min-width="50">
                <base-button @click="submit()" round icon type="green">
                  <i class="tim-icons icon-simple-add"></i>
                </base-button>
              </el-table-column>
            </el-table> -->
          </div>
          <div class="col-md-11" style="margin-top: 3%">
            <div class="row">
              <div class="col-lg-1">
                <b>No</b>
              </div>
              <div class="col">
                <b>Langkah Kawalan</b>
              </div>
              <div class="col">
                <b>Rancangan Tindakan Pencegahan / Pembetulan</b>
              </div>
              <div class="col">
                <b style="text-align: center;">Tarikh</b>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-1" >
                <b>1.</b>
              </div>
              <div class="col">
                <base-input v-model="PvStepTypeId0" disabled>
                </base-input>
              </div>
              <div class="col">
                <base-input>
                  <textarea class="address" v-model="StepDetail0" style="width: 300px;height: 150px;"></textarea>
                </base-input>
              </div>
              <div class="col">
                <base-input>
                  <el-date-picker type="date" v-model="DateExecComp0"></el-date-picker>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-1" >
                <b>2.</b>
              </div>
              <div class="col">
                <base-input v-model="PvStepTypeId1" disabled>
                </base-input>
              </div>
              <div class="col">
                <base-input>
                  <textarea class="address" v-model="StepDetail1" style="width: 300px;height: 150px;"></textarea>
                </base-input>
              </div>
              <div class="col">
                <base-input>
                  <el-date-picker type="date" v-model="DateExecComp1"></el-date-picker>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-1" >
                <b>3.</b>
              </div>
              <div class="col">
                <base-input v-model="PvStepTypeId2" disabled>
                </base-input>
              </div>
              <div class="col">
                <base-input>
                  <textarea class="address" v-model="StepDetail2" style="width: 300px;height: 150px;"></textarea>
                </base-input>
              </div>
              <div class="col">
                <base-input>
                  <el-date-picker type="date" v-model="DateExecComp2"></el-date-picker>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-1" >
                <b>4.</b>
              </div>
              <div class="col">
                <base-input v-model="PvStepTypeId3" disabled>
                </base-input>
              </div>
              <div class="col">
                <base-input>
                  <textarea class="address" v-model="StepDetail3" style="width: 300px;height: 150px;"></textarea>
                </base-input>
              </div>
              <div class="col">
                <base-input>
                  <el-date-picker type="date" v-model="DateExecComp3"></el-date-picker>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-1" >
                <b>5.</b>
              </div>
              <div class="col">
                <base-input v-model="PvStepTypeId4" disabled>
                </base-input>
              </div>
              <div class="col">
                <base-input>
                  <textarea class="address" v-model="StepDetail4" style="width: 300px;height: 150px;"></textarea>
                </base-input>
              </div>
              <div class="col">
                <base-input>
                  <el-date-picker type="date" v-model="DateExecComp4"></el-date-picker>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-1" >
                <b>6.</b>
              </div>
              <div class="col">
                <base-input v-model="PvStepTypeId5" disabled>
                </base-input>
              </div>
              <div class="col">
                <base-input>
                  <textarea class="address" v-model="StepDetail5" style="width: 300px;height: 150px;"></textarea>
                </base-input>
              </div>
              <div class="col">
                <base-input>
                  <el-date-picker type="date" v-model="DateExecComp5"></el-date-picker>
                </base-input>
              </div>
            </div>

            <!-- <el-table :data="tableETD" style="border: solid white; border-radius: 10px; ">
              <el-table-column
                min-width="100"
                sortable
                align="center"
                label="Langkah Kawalan"
                property="langkahKawalan"
              ></el-table-column> -->
              <!-- <el-table-column
                min-width="250"
                sortable
                align="center"
                label="Rancangan Tindakan Pencegahan / Pembetulan"
                property="tindakanPencegahan"
              >
                <textarea class="address" @change="capture" v-model="tindakanPencegahan" ></textarea>
              </el-table-column>
              <el-table-column
                min-width="90"
                sortable
                align="center"
                label="Tarikh"
                property="tarikSiap"
              >
                  <el-date-picker v-model="tarikSiap" type="date"></el-date-picker>
              </el-table-column> -->
              <!-- <el-table-column :min-width="25" align="right">
                <div slot-scope="props">
                  <base-button
                    @click.native="addinfo(props.$index, props.row)"
                    @click="openmodal = true"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="tim-icons icon-simple-add"></i>
                  </base-button>
                </div>
              </el-table-column>

              <modal
                :show.sync="openmodal"
                footer-classes="content-center"
                type="notice"
              >
                          <h3 slot="header" class="modal-title">Langkah Kawalan</h3>
                          <h5 class="text-left text-color">Maklumat tambahan bagi {{langkahKawalan}}</h5>
                          <div class="row">
                            <div class="col-md-12">
                              
                              <form @submit.prevent>
                                <div>
                                  <base-input
                                    type="text"
                                    label="Rancangan Tindakan"
                                    v-model="tindakan"
                                  ></base-input>
                                  <base-input
                                    type="text"
                                    label="Tarikh"
                                    v-model="tarikh"
                                  ></base-input>
                                  <base-button
                                    class="mt-3"
                                    native-type="submit"
                                    type="success"
                                    @click="save()"
                                  >Submit</base-button>
                                  <base-button
                                    class="mt-3"
                                    type="danger"
                                    @click.native="openmodal = false"
                                  >Cancel</base-button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </modal> -->
              <!-- <el-table-column :min-width="25" align="right">
                <div slot-scope="props">
                  <base-button
                    @click.native="handleDelete(props.$index, props.row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="tim-icons icon-simple-remove"></i>
                  </base-button>
                </div>
              </el-table-column> -->
            <!-- </el-table> -->
          </div>
        </div>
        <div class="row justify-content-center">
          <base-button @click="hantar()">Submit</base-button>
          <div class="d-flex justify-content-center spinner" v-if="load">
            <circle-8></circle-8>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";
import moment from "moment";
import swal from "sweetalert2";
import { Modal, TabPane, Tabs } from "src/components";
import { Circle8 } from "vue-loading-spinner";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";


export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    Modal,
    Loading,
    Circle8
  },
  data() {
    return {
      isLoading: false,
      dis: false,
      load: false,
      id0: "1",
      id1: "2",
      id2: "3",
      id3: "4",
      id4: "5",
      id5: "6",
      PvStepTypeId0: "Penghapusan",
      PvStepTypeId1: "Penggantian",
      PvStepTypeId2: "Pengasingan",
      PvStepTypeId3: "Kawalan Kejuruteraan",
      PvStepTypeId4: "Kawalan Pentadbiran",
      PvStepTypeId5: "Penggunaan PPE",
      StepDetail0: "",
      StepDetail1: "",
      StepDetail2: "",
      StepDetail3: "",
      StepDetail4: "",
      StepDetail5: "",
      DateExecComp0: "",
      DateExecComp1: "",
      DateExecComp2: "",
      DateExecComp3: "",
      DateExecComp4: "",
      DateExecComp5: "",
      langkahKawalanid:"",
      openmodal: false,
      quantity: "",
      assetName: "",
      assetNo: "",
      tindakanPencegahan: "",
      capitalizedDate: "",
      costCentre: "",
      condition: "",
      location: "",
      langkahKawalan: "",
      tarikSiap: "",
      value1: "",
      tableDetails: [],
      investigator: [],
      tindakan: "",
      tarikh: "",
      // {
      //   nokawalankes: "",
      //   name: "",
      //   nostaf: "",
      //   servicearea: ""
      // },
      maklumat: [],
      indate: "",
      intimestamp: "",
      intime: "",
      inlocationdetail: "",
      weather: "",
      surr: "",
      propdamage: "",
      injury: "",
      insummary: "",
        // inimage: "",
        // imgdesc: "",
      punca: {
        man: "",
        machine: "",
        material: "",
        method: ""
      },
      pencegahan:[],
      selects: {
        condition: [
          { value: "operational", label: "Operational" },
          { value: "Not operational", label: "Not Operational" }
        ],
        kawalan: [],
        location: [
          { value: "HQ", label: "HQ" },
          { value: "Off HQ", label: "Off HQ" }
        ],
        costCentre: [
          { value: "Cost 1", label: "Cost 1" },
          { value: "Cost 2", label: "Cost 2" }
        ]
      },
      tableETD: [],
      model: {
        file: null
      },
      img: [],
      lk:[]
    };
  },
  mounted(){
    this.panggil()
    this.$root.$on("investigatordetail", investigator => {
      this.investigator = investigator
    });
    this.fourthstep();
    this.fifthstep();
    this.investigationdata();
    this.imagedata();
  
  },
  methods: {
    save(){

      // let tarikh = moment(this.tarikh)
      // let tt = tarikh.format('YYYY-MM-DD')

      // for(var i=0; i<7; i++){
      let data = {
        langkahKawalan: this.langkahKawalan ,
        langkahKawalanid: parseInt(this.langkahKawalanid),
        // parseInt(this.langkahkawalanid),
        tindakanPencegahan: this.tindakan,
        tarikSiap: this.tarikh
      }
      console.log(data)
      
      for(var i=0; i<this.tableETD.length; i++){
        if(data.langkahKawalanid === this.tableETD[i].langkahKawalanid){
          this.tableETD.splice(i,1,data)
        }
      }

      console.log(this.tableETD)
      // this.sendfourthstep(this.editdata)

        // this.tableETD.splice()

        // objindex = this.tableETD.findIndex((obj => obj.langkahkawalanid === langkahkawalanid))

        // const updatedobj = {...this.tableETD[objindex], desc: 'kl'}
        // const updatedProjects = [
        //   ...this.tableETD.slice(0, objindex),
        //   updatedobj,
        //   ...this.tableETD.slice(objindex + 1),
        // ];
      

      // console.log(this.lk)

      this.langkahkawalanid = ""
      this.tindakan = ""
      this.tarikh = ""
      this.openmodal = false
    },
    addinfo(index, row){
      this.langkahKawalan = `${row.langkahKawalan}`
      this.langkahKawalanid = `${row.langkahKawalanid}`
      this.tindakanPencegahan = "",
      this.tarikSiap = ""
    },
    panggil(){
      this.getpvstep();
    },
    onFileChange(file) {
      this.file = file;
    },
    validate() {
      this.$emit("on-validated", true, this.model);
      return Promise.resolve(true);
    },
    getpvstep(){
      this.$http.get(":9994/api/v1/incident/pvsteplist")
        .then(res =>{
          if (!res.error){
            let response = res.message
            console.log(response)
            for(var i=0; i<response.length; i++){
              let data = {
                langkahKawalanid: parseInt(response[i].PvStepTypeId),
                langkahKawalan: response[i].PvStepName,
                // parseInt(this.langkahkawalanid),
                tindakanPencegahan: "",
                tarikSiap: ""
              }
              // let data = {
              //   langkahKawalan: response[i].PvStepName,
              //   langkawalanid: response[i].PvStepTypeId
              // }
              

              this.tableETD.push(data)
            }
            
          }
        })
    },
    investigationdata(){
      this.$root.$on("investigatordata", investigatordata =>{
        console.log(investigatordata);
        // this.indate = investigatordata.indate
        // this.intime = investigatordata.intime
        this.intimestamp = investigatordata.intimestamp
        this.inlocationdetail = investigatordata.inlocationdetail
        this.weather = investigatordata.weather
        this.surr = investigatordata.surr
        this.injury = investigatordata.injury
        this.propdamage = investigatordata.propdamage
        this.insummary = investigatordata.insummary
      })
    },
    imagedata(){
      this.$root.$on("imagedata", images =>{
        console.log(images)
        this.img = images
        // this.img = img
        // this.img = images
        // let imagedesc = ""
        // console.log(imagedata)
        // for(var i=0; i<images.length; i++){
        // //   // convert to base64 
        //   const reader = new FileReader()

        //   reader.onload = (event) => {
        //   images[i].imagefile = event.target.result
        //   console.log(images[i].imagefile)
        //       // rebuild cropperjs with the updated source
        //   // this.$refs.cropper.replace(event.target.result)
        //   }
        //   // reader.readAsDataURL(file)
        //   // console.log(reader.readAsDataURL(imagedata[i].imagefile))
        //   // console.log(imagedata[i].imagefile.toString())
        //   // imagedesc= imagedata[i].imagedata

        //   let imk = {
        //     imagefile: images[i].imagefile,
        //     imagedesc: images[i].imagedesc
        //   }
        
        //   this.img.push(imk)
        // }

          
        // console.log(this.img)
        })
    },
    fourthstep(){
      this.$root.$on('fourthstep',data =>{
        console.log(data)
        this.maklumat = data
      })
    },
    fifthstep(){
      this.$root.$on("fifthpage", fifth =>{
        console.log(fifth)
        this.punca.man = fifth.man
        this.punca.machine = fifth.machine
        this.punca.material = fifth.material
        this.punca.method = fifth.method
      })
    },
    submit(){
      // arrange action data
      console.log(this.tarikSiap)
      let tarikh = moment(this.tarikSiap)
      let tt = tarikh.format('YYYY-MM-DD')
      let data = {
        langkahKawalan: parseInt(this.langkahKawalan),
        tindakanPencegahan: this.tindakanPencegahan,
        tarikSiap: tt
      }

      this.tableDetails.push(data)
      
      this.langkahKawalan = ""
      this.tindakanPencegahan = ""
      this.tarikSiap = ""
    },
    hantar(){
      this.load = true;
      this.isLoading = true;
      console.log(this.investigator)
      console.log(this.maklumat)
      console.log(this.punca.man)
      console.log(this.punca.machine)
      console.log(this.punca.material)
      console.log(this.punca.method)
      console.log(this.tableDetails)
      console.log(this.intimestamp)
      console.log(this.indate)
      console.log(this.intime) 
      console.log(this.inlocationdetail)
      console.log(this.weather)
      console.log(this.surr)
      console.log(this.injury)
      console.log(this.propdamage)
      console.log(this.insummary)

      console.log(this.img)
      // arrange action data
      let data = []

      let tarikh0 = moment(this.DateExecComp0)
      let tt0 = tarikh0.format('YYYY-MM-DD')

      let tarikh1 = moment(this.DateExecComp1)
      let tt1 = tarikh1.format('YYYY-MM-DD')

      let tarikh2 = moment(this.DateExecComp2)
      let tt2 = tarikh2.format('YYYY-MM-DD')

      let tarikh3 = moment(this.DateExecComp3)
      let tt3 = tarikh3.format('YYYY-MM-DD')

      let tarikh4 = moment(this.DateExecComp4)
      let tt4 = tarikh4.format('YYYY-MM-DD')

      let tarikh5 = moment(this.DateExecComp5)
      let tt5 = tarikh5.format('YYYY-MM-DD')

      // invalid date handler
      if(tt0 == "Invalid date"){
        tt0 = ""
      }

      if(tt1 == "Invalid date"){
        tt1 = ""
      }

      if(tt2 == "Invalid date"){
        tt2 = ""
      }

      if(tt3 == "Invalid date"){
        tt3 = ""
      }

      if(tt4 == "Invalid date"){
        tt4 = ""
      }

      if(tt5 == "Invalid date"){
        tt5 = ""
      }

      data[0] = {
        langkahKawalan: parseInt(this.id0),
        tindakanPencegahan: this.StepDetail0,
        tarikSiap: tt0
      }

      data[1] = {
        langkahKawalan: parseInt(this.id1),
        tindakanPencegahan: this.StepDetail1,
        tarikSiap: tt1
      }

      data[2] = {
        langkahKawalan: parseInt(this.id2),
        tindakanPencegahan: this.StepDetail2,
        tarikSiap: tt2
      }

      data[3] = {
        langkahKawalan: parseInt(this.id3),
        tindakanPencegahan: this.StepDetail3,
        tarikSiap: tt3
      }

      data[4] = {
        langkahKawalan: parseInt(this.id4),
        tindakanPencegahan: this.StepDetail4,
        tarikSiap: tt4
      }

      data[5] = {
        langkahKawalan: parseInt(this.id5),
        tindakanPencegahan: this.StepDetail5,
        tarikSiap: tt5
      }

      console.log(data)

      let data2 = {
        investigator : this.investigator,
        investigation : this.maklumat,
        // indate: this.indate,
        // intime: this.intime,
        intimestamp: this.intimestamp,
        inlocationdetail: this.inlocationdetail,
        weather: this.weather,
        surr: this.surr,
        injury: this.injury,
        propdamage: this.propdamage,
        insummary: this.insummary,
        image: this.img,
        man : this.punca.man,
        machine : this.punca.machine,
        material: this.punca.material,
        method : this.punca.method,
        action : data,

      }

      console.log(data2)

      // hantaq backend
      this.$http.post(":9994/api/v1/incident/investigation" , data2)
        .then(res=>{
          if(!res.error){
            this.load = false
            this.isLoading = false
             swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false
            }).then(okay => {
            if (okay) {
              console.log("ok")
              this.$router.go()

            }
            });
            // this.$router.go()
          } else{
            this.load = false
            this.isLoading = false
            swal({
              title: "Data Error!",
              // text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false
            });
          }
        })
      

    }
  }
};
</script>
<style scoped>
textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
.huraian {
  width: 100%;
  height: 150px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
</style>
